

export class UserGroupLinking {
    group_id: string= "";
    user_id: string= "";
   
   
    
  }
